export const MAX_MCP_TOOLS_PER_SERVER = 100

// The router registers two tools whatever the connector count, so the only
// bound left is how much of the catalog one search may return.
export const MAX_CONNECTOR_SEARCH_RESULTS = 25

// The prompt lists what each connector can do so the agent routes to it without
// being told. Deliberately below the whitelist cap: a workspace may allow 100
// tools, but listing that many would crowd out every other connector.
export const MAX_DIGEST_TOOLS_PER_CONNECTOR = 20
export const MAX_DIGEST_SUMMARY_CHARS = 80
export const MAX_DIGEST_PROMPT_CHARS = 1800
// Names of the tools whose summary no longer fit. A name is what routing needs.
export const MAX_DIGEST_PROMPT_NAME_CHARS = 1200
// Stored unfiltered, so a whitelist change re-renders without a refetch.
export const MAX_DIGEST_STORED_TOOLS = 60

// An MCP connector reaches the customer-facing agent through its tools, so the
// stored flag is a mirror rather than the source, and a row written before the
// columns existed still reads correctly.
export function connectorReachesAgent(connector: {
	type: "HTTP" | "MCP"
	availableToAgent: boolean
	allowedMcpTools: readonly string[]
}): boolean {
	if (connector.type === "MCP") return connector.allowedMcpTools.length > 0
	return connector.availableToAgent
}

// Blocking is a restriction rather than a grant, so it is bounded only by how
// many tools a server may list at all.
export const MAX_BLOCKED_INTERNAL_MCP_TOOLS = 200

function normalizeToolNames(names: readonly string[]): string[] {
	return [
		...new Set(
			names.map((name) => name.trim()).filter((name) => name.length > 0),
		),
	].sort()
}

export function normalizeAllowedMcpTools(names: readonly string[]): string[] {
	const normalized = normalizeToolNames(names)

	if (normalized.length > MAX_MCP_TOOLS_PER_SERVER) {
		throw new Error(
			`An MCP connector can allow at most ${MAX_MCP_TOOLS_PER_SERVER} tools`,
		)
	}

	return normalized
}

export function normalizeBlockedInternalMcpTools(
	names: readonly string[],
): string[] {
	const normalized = normalizeToolNames(names)

	if (normalized.length > MAX_BLOCKED_INTERNAL_MCP_TOOLS) {
		throw new Error(
			`An MCP connector can block at most ${MAX_BLOCKED_INTERNAL_MCP_TOOLS} tools`,
		)
	}

	return normalized
}
